// extracted by mini-css-extract-plugin
export default {"fileRow":"FileRow_fileRow__nYXqX","selected":"FileRow_selected__O5cwD","version":"FileRow_version__bPOCi"};